var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoulette(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.4023C13.3265 14.4023 14.4019 13.3269 14.4019 12.0003C14.4019 10.6738 13.3265 9.59839 12 9.59839C10.6734 9.59839 9.59802 10.6738 9.59802 12.0003C9.59802 13.3269 10.6734 14.4023 12 14.4023Z",
    fill: "#FB8BA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.1993 7.74429L16.2556 8.80054L8.80068 16.2554L7.74443 15.1992L15.1993 7.74429Z",
    fill: "url(#paint0_linear_670_28845)",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M7.74447 8.80039L8.80072 7.74414L16.2556 15.199L15.1993 16.2553L7.74447 8.80039Z",
    fill: "url(#paint1_linear_670_28845)",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46535 9.37222C8.96616 9.37222 9.37216 8.96622 9.37216 8.46541C9.37216 7.96459 8.96616 7.55859 8.46535 7.55859C7.96453 7.55859 7.55853 7.96459 7.55853 8.46541C7.55853 8.96622 7.96453 9.37222 8.46535 9.37222Z",
    fill: "#FB8BA1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5347 16.4416C16.0355 16.4416 16.4415 16.0356 16.4415 15.5347C16.4415 15.0339 16.0355 14.6279 15.5347 14.6279C15.0339 14.6279 14.6279 15.0339 14.6279 15.5347C14.6279 16.0356 15.0339 16.4416 15.5347 16.4416Z",
    fill: "#FB8BA1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46535 16.4416C8.96616 16.4416 9.37216 16.0356 9.37216 15.5347C9.37216 15.0339 8.96616 14.6279 8.46535 14.6279C7.96453 14.6279 7.55853 15.0339 7.55853 15.5347C7.55853 16.0356 7.96453 16.4416 8.46535 16.4416Z",
    fill: "#FB8BA1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5347 9.37222C16.0355 9.37222 16.4415 8.96622 16.4415 8.46541C16.4415 7.96459 16.0355 7.55859 15.5347 7.55859C15.0339 7.55859 14.6279 7.96459 14.6279 8.46541C14.6279 8.96622 15.0339 9.37222 15.5347 9.37222Z",
    fill: "#FB8BA1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1.87163 15.9862L5.17471 14.6522C4.49419 12.8946 4.51536 10.9427 5.23382 9.20035L1.92257 7.88892C0.868087 10.4814 0.849855 13.3799 1.87163 15.9854",
    fill: "url(#paint2_linear_670_28845)",
    fillOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M9.20737 5.23116C10.963 4.50904 12.9301 4.4951 14.6958 5.19227L16.0072 1.88063C13.3918 0.849022 10.4792 0.866157 7.8761 1.92847L9.20737 5.23116Z",
    fill: "url(#paint3_linear_670_28845)",
    fillOpacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M22.0845 16.0951C23.1526 13.4564 23.1473 10.5047 22.0697 7.86987L18.7658 9.20386C19.5028 10.9925 19.5038 12.9998 18.7685 14.7891L22.0802 16.1006V16.0982L22.0845 16.0951Z",
    fill: "url(#paint4_linear_670_28845)",
    fillOpacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.9858 22.1287C13.3476 23.1627 10.4107 23.1306 7.79559 22.0392L9.10741 18.7268C10.8731 19.4836 12.8651 19.5184 14.6561 18.8236L15.9897 22.1271L15.9858 22.1287Z",
    fill: "url(#paint5_linear_670_28845)",
    fillOpacity: 0.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.92252 7.88896C2.47022 6.55089 3.27827 5.33494 4.29976 4.31171C5.32125 3.28849 6.53582 2.47837 7.87297 1.9284L9.20657 5.23148C7.40896 5.97606 5.98037 7.40368 5.23455 9.20079L1.92252 7.88896ZM22.0685 7.86874C21.5113 6.51493 20.6875 5.28702 19.646 4.25809C18.6046 3.22915 17.3669 2.42021 16.0064 1.87939L14.6942 5.19298C15.6065 5.5554 16.4369 6.09709 17.1363 6.78601C17.8356 7.47494 18.3897 8.2971 18.7658 9.2039L22.0716 7.87029L22.0685 7.86874ZM14.38 5.07708L14.3745 5.07514L14.38 5.07708ZM22.0806 16.1006L18.7681 14.7892C18.3898 15.7041 17.8302 16.533 17.1232 17.2261C16.4163 17.9192 15.5764 18.4621 14.6542 18.8222L15.9885 22.128C17.3581 21.5866 18.604 20.7736 19.6512 19.738C20.6983 18.7024 21.5251 17.4656 22.0817 16.1021L22.0806 16.1006ZM1.8708 15.9866C2.40536 17.3391 3.20472 18.5711 4.22194 19.6103C5.23916 20.6496 6.45375 21.4752 7.79441 22.0386L9.10623 18.7254C8.21397 18.3402 7.40707 17.7818 6.73231 17.0824C6.05754 16.383 5.52836 15.5566 5.17544 14.6511L1.86963 15.9859L1.8708 15.9866Z",
    fill: "#FB8BA1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_670_28845",
    x1: 5.12281,
    y1: 17.8201,
    x2: 6.40426,
    y2: 18.8345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320987,
    stopColor: "#FDE0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770645,
    stopColor: "#EEB8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6A3C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_670_28845",
    x1: 17.8203,
    y1: 18.8769,
    x2: 18.8347,
    y2: 17.5954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320987,
    stopColor: "#FDE0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770645,
    stopColor: "#EEB8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6A3C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_670_28845",
    x1: 5.23515,
    y1: 18.8334,
    x2: 1.37385,
    y2: 17.2225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320987,
    stopColor: "#FDE0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770645,
    stopColor: "#EEB8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6A3C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_670_28845",
    x1: 16.0098,
    y1: 6.67703,
    x2: 13.5454,
    y2: 2.67712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320987,
    stopColor: "#FDE0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770645,
    stopColor: "#EEB8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6A3C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_670_28845",
    x1: 22.883,
    y1: 18.9946,
    x2: 19.003,
    y2: 17.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320987,
    stopColor: "#FDE0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770645,
    stopColor: "#EEB8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6A3C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_670_28845",
    x1: 15.9924,
    y1: 24.3425,
    x2: 13.4994,
    y2: 20.3069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320987,
    stopColor: "#FDE0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770645,
    stopColor: "#EEB8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6A3C8"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoulette);
export default __webpack_public_path__ + "static/media/roulette.7ba228f7ace3837c32f1f92b5c36457d.svg";
export { ForwardRef as ReactComponent };